import { TabWrapper } from "./Tab.styles";
import { TabProps } from "./Tab.types";

export function Tab({ children, isActive }: TabProps) {
  return <TabWrapper>{isActive && children}</TabWrapper>;
}
